import { render, staticRenderFns } from "./TradingOrderBook.vue?vue&type=template&id=74016790&scoped=true&"
import script from "./TradingOrderBook.vue?vue&type=script&lang=js&"
export * from "./TradingOrderBook.vue?vue&type=script&lang=js&"
import style0 from "./TradingOrderBook.vue?vue&type=style&index=0&id=74016790&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74016790",
  null
  
)

export default component.exports